import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/basic-stores/host-management/$clubid/gallery')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
